import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoadService } from '@app/services/load.service';

@Component({
  selector: 'app-dialogo-confirmacion',
  templateUrl: './dialog-confirmation.component.html',
  styleUrls: ['./dialog-confirmation.component.scss'],
})
export class DialogConfirmationComponent implements OnInit {
  mensaje!: string;
  id!: string;
  loading: boolean = false;
  option!: string;
  constructor(
    private loadService: LoadService,
    public dialogo: MatDialogRef<DialogConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.mensaje = this.data.mensaje;
    this.id = this.data.id;
    this.option = this.data.option;
  }

  negativeAnswer(): void {
    this.dialogo.close();
  }

  positiveAnswer(): void {
    this.loading = true;
    let valueElement = document.getElementById('Process1');
    console.log(valueElement);
    valueElement?.classList.add('ocultar');
    let valueElement2 = document.getElementById('Process2');
    console.log(valueElement);
    valueElement2?.classList.add('ocultar');
    if (this.option == '1') {
      this.loadService.loadProcess(Number(this.id)).subscribe(
        (res) => {
          this.loading = false;
          this.dialogo.close();
        },
        () => {
          this.loading = false;
          let valueElement = document.getElementById('Process1');
          console.log(valueElement);
          valueElement?.classList.remove('ocultar');
          let valueElement2 = document.getElementById('Process2');
          console.log(valueElement);
          valueElement2?.classList.remove('ocultar');
        }
      );
    } else if (this.option == '2') {
      this.loadService.loadCancel(Number(this.id)).subscribe(
        (res) => {
          this.loading = false;
          this.dialogo.close();
        },
        () => {
          this.loading = false;
          let valueElement = document.getElementById('Process1');
          console.log(valueElement);
          valueElement?.classList.remove('ocultar');
          let valueElement2 = document.getElementById('Process2');
          console.log(valueElement);
          valueElement2?.classList.remove('ocultar');
        }
      );
    }
  }

  ngOnInit() {
    console.log(this.data);
  }
}
